module.exports = __webpack_public_path__ + "assets/img/249b120b83c256b6b60713ae40f805d6.svg";